export const getStyles = () => ({
  heroContainer: {
    paddingTop: "64px",
    backgroundColor: "#FFC02C",
    overflow: "hidden",
  },
  heroSection: {
    display: "grid",
    position: "relative",
    minHeight: "610px",
    justifyItems: "center",
    paddingBlock: "32px 0",

    "@media (min-width: 960px)": {
      minHeight: "80%",
      gridColumn: "2 / -2",
      paddingBlock: "120px",
      gridTemplateColumns: "repeat(2, 50%)",
    },
  },
  heroImage: {
    position: "absolute",
    inset: 0,
    display: "flex",
    justifyContent: "center",
    animation: "slideInUp 1s ease forwards",

    "& img": {
      height: "100%",
      width: "auto",
      objectFit: "contain",
      objectPosition: "center",
      mask: "linear-gradient(180deg, transparent, #ffdb92  15%)"
    },
    "@media (min-width: 960px)": {
      gridColumn: "1 / 2",
      animation: "moveInLeft 1s ease forwards",
      "& img": {
        scale: "1.5",
      },
    },
  },
  heroDescription: {
    maxWidth: "240px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    zIndex: 2,
    color: "#222",
    gap: "12px",

    "& h1": {
      fontSize: "1.5rem",
      lineHeight: 0.9,
      fontStyle: "normal",
      animation: "moveInRight 1s ease forwards",

      "& strong": {
        fontWeight: "900",
      },
    },

    "& p": {
      fontSize: "0.813rem",
      animation: "moveInRight 1.5s ease forwards",
    },

    "@media (min-width: 960px)": {
      gridColumn: "2 / 3",
      alignItems: "flex-start",
      justifySelf: "flex-start",
      alignSelf: "center",
      maxWidth: "568px",
      paddingLeft: "40px",
      gap: "54px",

      "& h1": {
        fontSize: "3.438rem",
        lineHeight: 0.9,
      },

      "& p": {
        maxWidth: "95%",
        fontSize: "2rem",
      },
    },
  },

  button: {
    marginTop: "auto",
    marginBottom: "72px",
    animation: "moveInRight 2s ease forwards",

    "&.MuiButton-containedInfo": {
      backgroundColor: "#fff",
      color: "#222",
    },
    "@media (min-width: 960px)": {
      marginTop: 0,
      marginBottom: 0,
    },
  },
});
